import { render, staticRenderFns } from "./RonovatecConfirmationDialogButton.vue?vue&type=template&id=fe36ab80&scoped=true&"
import script from "./RonovatecConfirmationDialogButton.vue?vue&type=script&lang=ts&"
export * from "./RonovatecConfirmationDialogButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36ab80",
  null
  
)

export default component.exports